import { render, staticRenderFns } from "./ProductsGridV2.vue?vue&type=template&id=b66d253e&scoped=true"
import script from "./ProductsGridV2.vue?vue&type=script&lang=js"
export * from "./ProductsGridV2.vue?vue&type=script&lang=js"
import style0 from "./ProductsGridV2.vue?vue&type=style&index=0&id=b66d253e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66d253e",
  null
  
)

export default component.exports